import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import AssumptionsAndDetails from './AssumptionsAndDetails/AssumptionsAndDetails';

const AssumptionsAndDetailsPicker = ({ resource }) => {
  return resource.withRelationship(fr.relationships.assumptionsAndDetails.name,
    (rel) => <AssumptionsAndDetails relationship={rel} />,
    () => null);
};

AssumptionsAndDetailsPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
AssumptionsAndDetailsPicker.defaultProps = {
};

export default AssumptionsAndDetailsPicker;
